// extracted by mini-css-extract-plugin
export default {"color":"ElectricRateBasicPrice_color__pM30L","pricingMethod":"ElectricRateBasicPrice_pricingMethod__s4z-S"};